import { useContext } from 'react'
import { useQuery } from 'react-query'

//contexts
import AuthContext from 'context/AuthContext'
//services
import { getAllGiftCards } from 'services/giftCardsService'
//utils
import { handleError } from 'utils/utils'

const useQueryGiftCards = () => {
  const { user } = useContext(AuthContext)

  const { data, isLoading } = useQuery(['GIFT_CARDS'], () => getAllGiftCards(), {
    enabled: user?.country === 'United States',
    refetchOnWindowFocus: false,
    onError: handleError,
  })

  return { giftCards: data?.data, isLoadingGiftCards: isLoading }
}

export default useQueryGiftCards
